import { Flex, Space } from 'antd';
import { Subtitle, Text } from 'components/mvp-typography';
import { usePatientInfoContext } from 'features/patient/_utils/patient-info/hook-context-patientinfo';
import { complexityToAreaMap } from 'lib/documents/critical-areas';
import { addHexOpacity } from 'lib/utils/math/colors';
import { useMemo } from 'react';
import { COLOR_EXTREME, COLOR_MODERATE } from '../../colors';

export function CriticalAreasCard() {
  const { patientInfo } = usePatientInfoContext();
  const criticalAreas = useMemo(
    () => complexityToAreaMap[patientInfo.concussion!.subtype],
    [patientInfo]
  );

  return (
    <>
      <Flex gap={'large'} vertical>
        <CriticalArea
          label={'High Critical Areas'}
          areas={criticalAreas.high}
          color={COLOR_EXTREME}
        />

        {criticalAreas.medium.length > 0 && (
          <CriticalArea
            label="Medium Critical Areas"
            areas={criticalAreas.medium}
            color={COLOR_MODERATE}
          />
        )}
      </Flex>
    </>
  );
}

export interface CriticalAreaProps {
  label: string;
  areas: string[];
  color: string;
}

/**
 * A list of critical areas
 */
function CriticalArea(props: CriticalAreaProps) {
  return (
    <div>
      <Subtitle style={{ color: '#230056' }}>{props.label}</Subtitle>
      <Space
        wrap
        style={{
          border: `7px solid #${addHexOpacity(
            props.color.replace('#', ''),
            0.9
          )}`,
          padding: '24px 40px 24px 40px',
          borderRadius: 12,
          width: '100%'
        }}
        size={60 / 2.5}
      >
        {props.areas.map((area, i) => (
          <Text
            className="crx-typography body-normal"
            key={`${area}-${i}`}
            color={'initial'}
            style={{ fontWeight: 'bold' }}
          >
            {area}
          </Text>
        ))}
      </Space>
    </div>
  );
}
